<h2 mat-dialog-title>{{ 'administration.sync-monitoring.audit-dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.reset-dialog.environment' | translate }}:</span>
		<strong>{{ data.environmentName }}</strong>
	</p>
	<p class="audit-dialog-note">{{ 'administration.sync-monitoring.audit-dialog.description' | translate }}</p>

	<mat-radio-group [value]="allTables" (change)="allTables = $event.value">
		<mat-radio-button [value]="true">
			{{ 'administration.sync-monitoring.audit-dialog.all-tables' | translate: { count: data.tables.length } }}
		</mat-radio-button>
		<mat-radio-button [value]="false">
			{{ 'administration.sync-monitoring.audit-dialog.selected-tables' | translate: { count: selected.size } }}
		</mat-radio-button>
	</mat-radio-group>

	<div class="audit-dialog-tables">
		@for (table of data.tables; track table) {
			<mat-checkbox color="primary" [checked]="selected.has(table)" (change)="toggleTable(table, $event.checked)">{{ table }}</mat-checkbox>
		}
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" [disabled]="isLoading" (click)="onCancel()">
		{{ 'general.cancel' | translate }}
	</button>
	<button mat-flat-button color="primary" type="button" [disabled]="!canStart" (click)="onStart()">
		@if (isLoading) {
			<mat-progress-spinner diameter="18" mode="indeterminate" class="audit-dialog-spinner"></mat-progress-spinner>
		}
		{{ 'administration.sync-monitoring.audit-dialog.confirm' | translate }}
	</button>
</mat-dialog-actions>
